import {
  ArgentinaMap as SharedArgentinaMap,
  type ArgentinaMapLabels,
} from '@sica/ui';
import { STATUS_LABELS } from '@/data/coverage';
import { useLiveCoverage } from '@/hooks/useLiveCoverage';

/**
 * El mapa de cobertura del sitio: la grilla esquemática compartida
 * (`@sica/ui`) alimentada con lo que mide
 * `GET /api/curricular/jurisdictions/coverage`, la misma consulta que pinta el
 * mapa de la docente.
 *
 * Antes se alimentaba de una tabla escrita a mano con su `TODO(12.4)`. Las
 * celdas siguen siendo objetivos de hover y foco solamente: el mapa declara
 * cobertura, no navega.
 */
export function ArgentinaMap({ compact = false }: { compact?: boolean } = {}) {
  const { isLoading, isAvailable, jurisdictions } = useLiveCoverage();

  if (isLoading) {
    return (
      <div
        className="min-h-[24rem] animate-pulse rounded-lg border border-line bg-paper-tinted/60"
        aria-hidden="true"
      />
    );
  }

  // Nunca se cae de vuelta a la tabla estática: eso reintroduciría exactamente
  // la afirmación sin consulta que este cambio saca del sitio.
  if (!isAvailable) {
    return (
      <div className="rounded-lg border border-line bg-paper-tinted/40 px-6 py-12 text-center">
        <p className="font-serif text-lg text-ink">
          No pudimos consultar la cobertura en este momento.
        </p>
        <p className="mx-auto mt-3 max-w-prose text-base leading-relaxed text-ink-muted">
          El mapa muestra lo que el inventario curricular tiene cargado, medido en el momento en que
          abrís la página. Preferimos decirte que no pudimos leerlo antes que mostrarte un estado que
          no verificamos.
        </p>
      </div>
    );
  }

  return <SharedArgentinaMap jurisdictions={jurisdictions} labels={LABELS} compact={compact} />;
}

const LABELS: ArgentinaMapLabels = {
  mapLabel: 'Mapa de cobertura por jurisdicción',
  detailKicker: 'Jurisdicción',
  detailIdle: 'Pasá el cursor sobre una jurisdicción para ver su estado de cobertura.',
  legendTitle: 'Referencias',
  statuses: STATUS_LABELS,
};
